interface CellProps {
  parent: JSX.Element;
  child: JSX.Element;
  isChild: boolean;
}

const DepthControlCell = ({ parent, child, isChild }: CellProps) => {
  return isChild ? child : parent;
};

export default DepthControlCell;
